import { useState, useEffect, useCallback } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import mainTheme from '../../themes/mainTheme';
var BreakpointProvider = /** @class */ (function () {
    function BreakpointProvider(customBreakpoints) {
        this.breakpoints = {
            values: mainTheme.breakpoints
        };
        if (customBreakpoints) {
            this.breakpoints = {
                values: customBreakpoints
            };
        }
        this.mediaQueries = {
            regular: {
                small: "(max-width: " + this.breakpoints.values.sm + "px)",
                medium: "(min-width: " + this.breakpoints.values.sm + "px) and (max-width: " + this.breakpoints.values.md + "px)",
                large: "(min-width: " + this.breakpoints.values.md + "px) and (max-width: " + this.breakpoints.values.lg + "px)",
                'extra-large': "(min-width: " + this.breakpoints.values.lg + "px)"
            },
            mobileFirst: {
                small: "(max-width: " + this.breakpoints.values.sm + "px)",
                medium: "(min-width: " + this.breakpoints.values.sm + "px)",
                large: "(min-width: " + this.breakpoints.values.md + "px)",
                'extra-large': "(min-width: " + this.breakpoints.values.lg + "px)"
            }
        };
    }
    return BreakpointProvider;
}());
// export const AppBreakpoints = new BreakpointProvider()
export var getBPHelpers = function (breakpoints) {
    var AppBreakpoints = new BreakpointProvider(breakpoints);
    var screens = function () {
        var sizes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sizes[_i] = arguments[_i];
        }
        var validSizes = sizes.filter(function (size) { return AppBreakpoints.mediaQueries.regular[size]; });
        if (validSizes.length === 0) {
            return '';
        }
        var mediaQueries = validSizes.map(function (size) { return AppBreakpoints.mediaQueries.regular[size]; }).join(', ');
        return "@media " + mediaQueries;
    };
    var screenSizeToBreakpointKey = function (size) {
        /**
         * Gets a screen size nickname that corresponds to the given screen size.
         *
         * @param {number} size Screen size
         */
        var _a = AppBreakpoints.breakpoints.values, sm = _a.sm, md = _a.md, lg = _a.lg;
        if (size < sm) {
            return 'small';
        }
        else if (size >= sm && size < md) {
            return 'medium';
        }
        else if (size >= md && size < lg) {
            return 'large';
        }
        return 'extra-large';
    };
    var isScreenSize = function (size, currentSize) {
        var sizeToUse = currentSize || window.innerWidth;
        var foundBreakpoint = screenSizeToBreakpointKey(sizeToUse);
        return size === foundBreakpoint;
    };
    var useScreenSize = function () {
        var _a = useState(window.innerWidth), width = _a[0], setWidth = _a[1];
        var _b = useState(window.innerHeight), height = _b[0], setHeight = _b[1];
        var updateSize = function () {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', vh + "px");
        };
        useEffect(function () {
            window.addEventListener('resize', updateSize);
            return function () {
                window.removeEventListener('resize', updateSize);
            };
        }, []);
        return {
            width: width,
            height: height
        };
    };
    var useBreakpoint = function (sizes) {
        var mediaQueryString = screens.apply(void 0, [].concat(sizes));
        // const mediaQuery = useMediaQuery(mediaQueryString, {noSsr: true}) in case we run into issue with double rendering
        var mediaQuery = useMediaQuery(mediaQueryString);
        if (!mediaQueryString)
            return false;
        return mediaQuery;
    };
    /**
     * Returns a function that picks a value from a {screenSize=>anyValue} object map.
     *
     * The function returned accepts 2 arguments:
     * 1. An object mapping values to screen size nicknames, e.g.
     *   {small: 'secondary-blue', large: 'primary-green'}
     * 2. A default value to use if no keys match in the object
     *
     * The function returns a value from the first argument that corresponds to the current
     * screen size, or the default value, if no corresponding key found.
     *
     * The returned function is memoized per screen size name.
     *
     * @example <caption>Varying both `variant` prop and button text with using the hook</caption>
     * const screens = useScreens()
     * <Button
     *   variant={screens(
     *     {
     *       small: 'secondary-blue',
     *       large: 'primary-green'
     *     },
     *     'primary-blue'
     *   )}
     * >
     * {screens(
     *   {
     *     small: 'small (secondary-blue)',
     *     large: 'large (primary-green)'
     *   },
     *   'default (primary-blue)'
     * )}
     * </Button>
     */
    var useScreens = function () {
        // Get current screen size in pixels, e.g. 800
        var currentSize = useScreenSize();
        // Convert the retrieved screen size in pixels (e.g. 800)
        // to its corresponding screen size name (e.g. 'large')
        var screenKey = screenSizeToBreakpointKey(currentSize.width);
        // For every screenKey value, memoize the instance of a function
        // that picks a property from an object by screen name,
        // and return this memoized version of the function.
        return useCallback(function (valuesByScreen, defaultValue) {
            if (defaultValue === void 0) { defaultValue = undefined; }
            if (screenKey in valuesByScreen) {
                return valuesByScreen[screenKey];
            }
            return defaultValue;
        }, [screenKey]);
    };
    return {
        AppBreakpoints: AppBreakpoints,
        screens: screens,
        isScreenSize: isScreenSize,
        useScreenSize: useScreenSize,
        useBreakpoint: useBreakpoint,
        useScreens: useScreens
    };
};
//# sourceMappingURL=breakpoints.js.map